import React from 'react'
import ReactStars from "react-rating-stars-component";
import { Link, useLocation } from 'react-router-dom';
import wish from '../images/wish.svg'
import watch1 from '../images/watch.jpg'
import watch2 from '../images/watch-01.avif'
import cart from '../images/add-cart.svg'
import view from '../images/view.svg'
import compare from '../images/prodcompare.svg'

const ProductCard = (props) => {
    const {grid} = props;
    let location = useLocation();
    
  return (
    <>
        <div className={` ${ location.pathname === "/product" ? `gr-${grid}` : "col-3" } `}>
            <Link to={`${ location.pathname === "/" ? "/product/:id" : location.pathname === "/product/:id" ? "/product/:id" : ":id" }`} className='product-card position-relative'>
                <div className='wishlist-icon position-absolute'>
                    <button className='border-0 bg-transparent'><img src={wish} alt='wishlist' /></button>
                </div>
                <div className='product-image'>
                    <img src={watch1} className='img-fluid' alt='product 1' />
                    <img src={watch2} className='img-fluid' alt='product second 1' />
                </div>
                <div className='product-details'>
                    <h6 className='brand'>Havels</h6>
                    <h5 className='product-title'>
                        Kids headphones bulk 10 pack multi colored for students.
                    </h5>
                    <ReactStars count={5} value={4} size={24} edit={false} activeColor="#ffd700" />
                    <p className={`description ${grid === 12 ? "d-block" : "d-none"}`}>
                    "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis 
                    praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias 
                    excepturi sint occaecati cupiditate non provident, similique sunt...
                    </p>
                    <p className='price'>Kshs 10,000.00</p>
                </div>
                <div className='action-bar position-absolute'>
                    <div className='d-flex flex-column gap-15'>
                        <button className='border-0 bg-transparent'>
                            <img src={cart} alt='add to cart' />
                        </button>
                        <button className='border-0 bg-transparent'>
                            <img src={view} alt='view' />
                        </button>
                        <button className='border-0 bg-transparent'>
                            <img src={compare} alt='compare' />
                        </button>
                    </div>
                </div>
            </Link>
        </div>
        <div className={` ${ location.pathname === "/product" ? `gr-${grid}` : "col-3" } `}>
            <Link to={`${ location.pathname === "/" ? "/product/:id" : location.pathname === "/product/:id" ? "/product/:id" : ":id" }`} className='product-card position-relative'>
                <div className='wishlist-icon position-absolute'>
                    <Link><img src={wish} alt='wishlist' /></Link>
                </div>
                <div className='product-image'>
                    <img src={watch1} className='img-fluid' alt='product' />
                    <img src={watch2} className='img-fluid' alt='product second' />
                </div>
                <div className='product-details'>
                    <h6 className='brand'>Havels</h6>
                    <h5 className='product-title'>
                        Kids headphones bulk 10 pack multi colored for students.
                    </h5>
                    <ReactStars count={5} value={4} size={24} edit={false} activeColor="#ffd700" />
                    <p className={`description ${grid === 12 ? "d-block" : "d-none"}`}>
                    "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis 
                    praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias 
                    excepturi sint occaecati cupiditate non provident, similique sunt...
                    </p>
                    <p className='price'>Kshs 10,000.00</p>
                </div>
                <div className='action-bar position-absolute'>
                    <div className='d-flex flex-column gap-15'>
                        <button className='border-0 bg-transparent'>
                            <img src={cart} alt='add to cart' />
                        </button>
                        <button className='border-0 bg-transparent'>
                            <img src={view} alt='view' />
                        </button>
                        <button className='border-0 bg-transparent'>
                            <img src={compare} alt='compare' />
                        </button>
                    </div>
                </div>
            </Link>
        </div>
    </>
  );
};

export default ProductCard